module.exports = "/packs/images/sprites/map~f104b9d7dd5784ac9e855270c32c9a30.png";